import { Reveal, SectionHeading } from "@/components/Reveal";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";

const faqs = [
  { q: "È necessario prenotare?", a: "La prenotazione non è sempre obbligatoria, ma è consigliata per assicurarsi la disponibilità dei piatti desiderati e ridurre i tempi di attesa." },
  { q: "Il menù è sempre uguale?", a: "No. Il menù può cambiare ogni giorno in base alle preparazioni, alla stagionalità e alla disponibilità degli ingredienti." },
  { q: "Posso prenotare tramite WhatsApp?", a: "Sì, è possibile inviare una richiesta tramite WhatsApp. L'ordine sarà considerato confermato solamente dopo aver ricevuto una risposta da parte di SAPORÉ." },
  { q: "Effettuate consegne a domicilio?", a: "Oltre al ritiro presso la gastronomia, sarà disponibile anche il servizio di consegna a domicilio tramite Deliveroo. Il servizio sarà attivato in prossimità dell'apertura di SAPORÉ e sarà possibile ordinare direttamente tramite la piattaforma Deliveroo." },
  { q: "Preparate menù per feste ed eventi?", a: "Sì. Realizziamo proposte per feste private, riunioni, eventi e buffet. Il menù viene definito in base al numero di partecipanti e alle esigenze del cliente." },
  { q: "È possibile richiedere confezioni monoporzione?", a: "Sì, previa richiesta e in base alla tipologia di preparazione scelta." },
  { q: "Come posso conoscere i piatti del giorno?", a: "Puoi consultare la sezione Piatti del giorno del sito, seguire i nostri canali social oppure contattarci telefonicamente o tramite WhatsApp." },
  { q: "I prodotti sono sempre disponibili?", a: "La disponibilità può cambiare nel corso della giornata. Alcuni piatti possono terminare prima dell'orario di chiusura." },
  { q: "Come vengono comunicati gli allergeni?", a: "Le informazioni sugli allergeni presenti nelle nostre preparazioni sono disponibili presso il punto vendita. In caso di allergie o intolleranze, ti invitiamo a comunicarcelo prima di effettuare l'ordine, così da poterti fornire tutte le informazioni necessarie." },
  { q: "Posso richiedere modifiche ai piatti?", a: "Le richieste vengono valutate in base alla preparazione e all'organizzazione giornaliera della cucina. Non tutte le modifiche possono essere garantite." },
  { q: "Accettate pagamenti elettronici e buoni pasto?", a: "Sì. Accettiamo contanti, carte e pagamenti tramite POS. Saranno inoltre accettati i buoni pasto abilitati presso SAPORÉ. L'elenco dei circuiti disponibili sarà comunicato all'attivazione del servizio." },
];

export default function Faq() {
  return (
    <section id="faq" className="py-24 md:py-32 lg:py-40 bg-sand/60">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <SectionHeading
            overline="Domande frequenti"
            title={<>Tutto quello che <span className="italic text-terracotta">devi sapere</span></>}
          />
          <Reveal delay={0.1}>
            <p className="mt-6 text-sm md:text-base text-charred/60 leading-relaxed">
              Non trovi la risposta che cercavi? Chiamaci o scrivici su WhatsApp: ti risponderemo il prima possibile.
            </p>
          </Reveal>
        </div>
        <div className="lg:col-span-8">
          <Reveal delay={0.15}>
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {faqs.map((f, i) => (
                <AccordionItem key={i} value={`faq-${i}`} className="border-charred/10">
                  <AccordionTrigger data-testid={`faq-question-${i}`} className="text-left font-serif text-xl md:text-2xl text-charred hover:text-terracotta hover:no-underline py-5">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-sm md:text-base text-charred/70 leading-relaxed pb-6">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
